
import getGoogleAnalyticsId from "./getGoogleAnalyticsId";
import getFacebookPixelId from "./getFacebookPixelId";

export default {

    getGoogleAnalyticsId,
    getFacebookPixelId,
    
}